<template>
  <div class="layout">
    <div class="header" />
    <div class="tips">
      <div class="tip"><slot name="tip1"/></div>
      <div class="tip"><slot name="tip2"/></div>
      <div class="tip"><slot name="tip3"/></div>
      <div class="tip"><slot name="tip4"/></div>
      <div class="tip"><slot name="tip5"/></div>
      <div class="tip"><slot name="tip6"/></div>
      <div class="tip"><slot name="tip7"/></div>
      <div class="tip"><slot name="tip8"/></div>
    </div>
    <div class="main">
      <div class="left">
        <div class="area">
          <div class="area-header"></div>
          <div class="left-content">
            <slot name="area" />
          </div>
        </div>
        <div class="year">
          <div class="year-header"></div>
          <div class="left-content">
            <slot name="year" />
          </div>
        </div>
      </div>
      <div class="map">
        <div class="map-tip"><slot name="map-tip" /></div>
        <slot name="map" />
      </div>
    </div>
    <div class="footer">
      <div class="enterprise cell">
        <div class="top"></div>
        <div class="footer-main">
          <slot name="enterprise"/>
        </div>
      </div>
      <div class="statistics cell">
        <div class="top"></div>
        <div class="footer-main">
          <slot name="statistics"/>
        </div>
      </div>
      <div class="proportion cell">
        <div class="top"></div>
        <div class="footer-main">
          <slot name="proportion"/>
        </div>
      </div>
      <div class="record cell">
        <div class="top"></div>
        <div class="footer-main">
          <slot name="record"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.layout {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url('~@/assets/background.jpg');
  background-size: 100% 100%;
  .header {
    height: 8vh;
  }
  .tips {
    height: 8vh;
    padding: 0 5vw;
    display: flex;
    .tip {
      padding-left: 4.5%;
      height: 100%;
      box-sizing: border-box;
      color: #fff;
      &:nth-of-type(1) {
        margin-left: .5%;
        width: 12%;
      }
      &:nth-of-type(2) {
        margin-left: 1%;
        width: 12.5%;
        padding-right: 1%;
      }
      &:nth-of-type(3) {
        width: 12.5%;
        padding-right: .5%;
      }
      &:nth-of-type(4) {
        margin-left: .5%;
        width: 12.3%;
        padding-right: .5%;
      }
      &:nth-of-type(5) {
        width: 12.2%;
        padding-right: .8%;
      }
      &:nth-of-type(6) {
        width: 12.5%;
        padding-right: 1%;
      }
      &:nth-of-type(7) {
        width: 12.2%;
        padding-right: 1%;
      }
      &:nth-of-type(8) {
        flex-grow: 1;
        padding-right: .7%;
      }
    }
  }
  .main {
    height: 41vh;
    padding: 0 5%;
    display: flex;
    .left {
      height: 100%;
      width: 54%;
      box-sizing: border-box;
      padding-top: 1vh;
      padding-right: .8%;
      display: flex;
      .area {
        height: 100%;
        width: 60%;
        .area-header {
          height: 13%;
        }
        .left-content {
          height: 87%;
        }
      }
      .year {
        height: 100%;
        flex-grow: 1;
        box-sizing: border-box;
        padding-left: 1%;
        .year-header {
          height: 13%;
        }
        .left-content {
          height: 87%;
        }
      }
    }
    .map {
      height: 100%;
      flex-grow: 1;
      position: relative;
      .map-tip {
        position: absolute;
        width: 24%;
        height: 30%;
        bottom: 5%;
        left: 5%;
      }
    }
  }
  .footer {
    font-size: .5vw;
    height: 40.5vh;
    box-sizing: border-box;
    padding: 0 5%;
    padding-top: 1vh;
    display: flex;
    .cell {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      .top {
        height: 6vh;
      }
      .footer-main {
        height: 34.5vh;
      }
    }
    .enterprise {
      height: 100%;
      width: 21%;
      margin-right: .8%;
    }
    .proportion {
      height: 100%;
      width: 27.4%;
      margin-right: 1%;
    }
    .statistics {
      height: 100%;
      width: 23.2%;
      margin-right: .8%;
    }
    .record {
      height: 100%;
      flex-grow: 1;
    }
  }
}
</style>
